import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAppDispatch } from 'store/hooks';
import { setOnFormPage, setOnMethodRoute } from 'store/slices/methodForm';

/**
 * Tracks the current route and updates methodGrouping slice flags.
 * Must be called once in AppRoutes (ModulorApp.tsx).
 *
 * Method routes: /deposit, /deposit/:id, /withdrawal, /withdrawal/:id
 * Form pages: /deposit/:id, /withdrawal/:id (where :id is a number)
 */
export const useMethodGroupingRoute = () => {
  const { pathname } = useLocation();
  const dispatch = useAppDispatch();

  useEffect(() => {
    const isDepositList = pathname === '/deposit';
    const isDepositForm = /^\/deposit\/\d+/.test(pathname);
    const isWithdrawalList = pathname === '/withdrawal';
    const isWithdrawalForm = /^\/withdrawal\/\d+/.test(pathname);

    const isMethodRoute = isDepositList || isDepositForm || isWithdrawalList || isWithdrawalForm;
    const isForm = isDepositForm || isWithdrawalForm;

    dispatch(setOnMethodRoute(isMethodRoute));
    dispatch(setOnFormPage(isForm));
  }, [pathname, dispatch]);
};
